(function () {
  if (window.vlImageWithTextSearchInitialized) return;

  window.vlImageWithTextSearchInitialized = true;

  function focusSearchInput() {
    window.setTimeout(function () {
      var popup = document.getElementById('headerPopupSearch');

      var input =
        popup?.querySelector('input[type="search"]') ||
        popup?.querySelector('input[name="q"]') ||
        document.querySelector('input[type="search"]') ||
        document.querySelector('input[name="q"]');

      if (input) {
        input.focus();
      }
    }, 200);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-vl-open-search]');

    if (!trigger) return;

    focusSearchInput();
  });
})();